import { grey } from "@mui/material/colors";
import type { ColorSystemOptions } from "@mui/material/styles";
import { aquamarine } from "./colors";
import type { ColorScheme } from "./types";

const common = { black: "#000000", white: "#ffffff" };

export const colorSchemes = {
  dark: {
    palette: {
      action: { disabledBackground: "rgba(0, 0, 0, 0.12)" },
      common,
      dividerChannel: "50 56 62",
      secondary: {
        light: grey[200],
        main: grey[400],
        dark: grey[500],
        contrastText: common.black,
      },
      primary: {
        light: aquamarine[50],
        main: aquamarine[300],
        dark: aquamarine[500],
        contrastText: common.black,
      },
    },
  },
  light: {
    palette: {
      action: {
        disabledBackground: "rgba(0, 0, 0, 0.06)",
        selectedOpacity: 0.15,
      },
      dividerChannel: "220 223 228",
      primary: {
        light: aquamarine[200],
        main: aquamarine[500],
        dark: aquamarine[700],
        contrastText: common.white,
      },
      secondary: {
        light: grey[400],
        main: grey[800],
        dark: grey[900],
        contrastText: common.white,
      },
    },
  },
} satisfies Partial<Record<ColorScheme, ColorSystemOptions>>;
